export enum ServiceNetworkEnum {
  SERVICE_NETWORK_TITLE = 'service-network--title',
  SERVICE_NETWORK_BREADCRUMB = 'service-network--breadcrumb',
  SERVICE_NETWORK_LIST = 'service-network--list',
  MAIN_SERVICE_NETWORK_LIST = 'service-network--main-service-network-list',
  VER_MAIS_BUTTON = 'service-network--ver-mais-button',
}
